import { render } from "./App.vue?vue&type=template&id=5c3740d0&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5c3740d0&lang=scss"

import exportComponent from "/home/devbayu1/Projects/revamp/edumu-sekolah/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__